module.exports = "<div class=\"js-loading-region l-loader\"></div> <div class=dd-list__filter> <div class=\"list-search list-search_dd\"> <input type=text class=\"list-search__input js-input\" placeholder=\"{{localize 'CORE.FORM.EDITORS.MEMBERSELECT.SEARCHPLACEHOLDER'}}\"> </div> </div> <div class=dd-list__list> <div class=\"js-list-region dd-list__wrp\"></div> <div class=\"js-scrollbar-region dd-list__scrollbar\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/memberSelect/templates/panel.hbs
// module id = 666
// module chunks = 0